import { Outlet } from "react-router";

import clientBackground from "@/assets/images/background.png";
import { ClientHeader } from "@/components/layout/client-header";
import { TciSessionProvider } from "@/providers/tci-session-provider";
import { VisitorTrackingProvider } from "@/providers/visitor-tracking-provider";

export function ClientLayout() {
  return (
    <TciSessionProvider>
      <VisitorTrackingProvider>
        <div className="relative flex min-h-dvh flex-col overflow-x-hidden bg-[#0b1628]">
          <img
            src={clientBackground}
            alt=""
            aria-hidden
            className="pointer-events-none absolute inset-0 size-full object-cover object-center"
          />

          <ClientHeader />
          <main className="relative z-10 flex flex-1 flex-col items-center">
            <div className="flex w-full flex-1 flex-col px-4 py-8 sm:px-6 sm:py-10 lg:px-8 lg:py-12">
              <div className="mx-auto flex w-full max-w-[892px] flex-1 flex-col">
                <Outlet />
              </div>
            </div>
          </main>
        </div>
      </VisitorTrackingProvider>
    </TciSessionProvider>
  );
}
